var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6519_132190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.29892 10.2665L7.87378 7.87318L10.2655 1.2999C10.3203 1.14932 10.4202 1.01925 10.5514 0.927339C10.6827 0.835431 10.8391 0.786133 10.9994 0.786133C11.1596 0.786133 11.316 0.835431 11.4473 0.927339C11.5785 1.01925 11.6784 1.14932 11.7332 1.2999L14.1265 7.87476L20.7013 10.2665C20.8519 10.3213 20.982 10.4211 21.0739 10.5524C21.1658 10.6837 21.2151 10.8401 21.2151 11.0003C21.2151 11.1606 21.1658 11.317 21.0739 11.4482C20.982 11.5795 20.8519 11.6793 20.7013 11.7342L14.1249 14.1275L11.7332 20.7023C11.6784 20.8529 11.5785 20.983 11.4473 21.0749C11.316 21.1668 11.1596 21.2161 10.9994 21.2161C10.8391 21.2161 10.6827 21.1668 10.5514 21.0749C10.4202 20.983 10.3203 20.8529 10.2655 20.7023L7.87221 14.1259L1.29892 11.7342C1.14834 11.6793 1.01827 11.5795 0.926363 11.4482C0.834455 11.317 0.785156 11.1606 0.785156 11.0003C0.785156 10.8401 0.834455 10.6837 0.926363 10.5524C1.01827 10.4211 1.14834 10.3213 1.29892 10.2665Z",
    stroke: "url(#paint0_linear_6519_132190)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6519_132190",
    x1: 0.785156,
    y1: 11.0011,
    x2: 21.2151,
    y2: 11.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF819D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438776,
    stopColor: "#FFB8D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF819D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6519_132190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.fa1b578e0f6a7d157e77e4f5ff1fb48b.svg";
export { ForwardRef as ReactComponent };